"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdPlacementBannerComponent = AdPlacementBannerComponent;
exports.default = AdPlacementBanner;
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _text = _interopRequireDefault(require("@ux/text"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _image = require("@site/pattern-library-core/image");
/** VENDOR **/

/** LOCAL **/

const AdPlacementBannerSection = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "AdPlacementBannerSection",
  class: "pl-a4kmhl0",
  vars: {
    "a4kmhl0-1": [({
      rounded
    }) => rounded === true ? _intents.default.ux.box.borderRadius : 'unset']
  }
});
const AdPlacement = /*#__PURE__*/(0, _react2.styled)("a")({
  name: "AdPlacement",
  class: "pl-a1wjk0r5",
  vars: {
    "a1wjk0r5-0": [({
      bannerSize
    }) => bannerSize === '300x250' ? '18.75rem' : `45.5rem`],
    "a1wjk0r5-2": [({
      rounded
    }) => rounded === true ? _intents.default.ux.box.borderRadius : 'unset'],
    "a1wjk0r5-6": [({
      sponsoredColor
    }) => sponsoredColor ? sponsoredColor : _intents.default.ux.boxLowContrast.backgroundColor]
  }
});
function AdPlacementBannerComponent({
  adBanner,
  eid = '',
  bannerSize,
  rounded,
  loading = 'lazy',
  sponsored,
  sponsoredColor
}) {
  const {
    clickUrl,
    imageUrl,
    impressionUrl,
    title = 'ad'
  } = adBanner;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(AdPlacement, {
    "data-cy": "image-placement",
    className: "image-placement",
    "aria-label": "image",
    target: "_blank",
    href: clickUrl,
    "data-eid": eid,
    bannerSize: bannerSize,
    rounded: rounded,
    sponsoredColor: sponsoredColor
  }, /*#__PURE__*/_react.default.createElement(_image.LazyPicture, {
    defaultSrc: imageUrl,
    defaultAltText: title,
    loading: loading,
    dataCy: "image"
  }, sponsored && /*#__PURE__*/_react.default.createElement(_text.default.span, {
    as: "paragraph",
    size: -1,
    className: "sponsored"
  }, sponsored))), /*#__PURE__*/_react.default.createElement(_image.LazyPicture, {
    defaultSrc: impressionUrl,
    defaultAltText: "impression",
    loading: "lazy",
    dataCy: "impression"
  }));
}
AdPlacementBannerComponent.propTypes = {
  adBanner: _propTypes.default.object.isRequired,
  bannerSize: _propTypes.default.oneOf(['728x90', '300x250']),
  rounded: _propTypes.default.bool,
  eid: _propTypes.default.string,
  loading: _propTypes.default.oneOf(['eager', 'lazy']),
  sponsored: _propTypes.default.string,
  sponsoredColor: _propTypes.default.string
};

/**
 * Render the Kevel placement ad.
 * @module AdPlacementBanner
 *
 * @param {object} props React props
 * @param {string} props._name Tracking name
 * @param {object} props.adBanner Data response from Kevel API, simplified from SWP
 * @param {string} props.verticalMargin Vertical margin size specification
 * @param {string} props.verticalPadding Vertical padding size specification
 * @returns {React.ReactElement} Kevel Ad Placement Banner
 * @public
 */
function AdPlacementBanner({
  adBanner,
  loading = 'lazy',
  verticalMargin = 'none',
  verticalPadding = 'small',
  bannerSize,
  rounded = false,
  padding,
  sponsored,
  sponsoredColor,
  eid = ''
}) {
  if (!(0, _patternLibraryUtils.hasDefinedProps)(adBanner, ['clickUrl', 'imageUrl', 'impressionUrl'])) return;
  return /*#__PURE__*/_react.default.createElement(AdPlacementBannerSection, {
    dataCy: "placement-banner-section",
    "aria-label": "placement-banner",
    verticalMargin: verticalMargin,
    verticalPadding: verticalPadding,
    rounded: rounded,
    padding: padding
  }, /*#__PURE__*/_react.default.createElement(AdPlacementBannerComponent, {
    adBanner: adBanner,
    bannerSize: bannerSize,
    rounded: rounded,
    loading: loading,
    eid: eid,
    sponsored: sponsored,
    sponsoredColor: sponsoredColor
  }));
}
AdPlacementBanner.propTypes = {
  adBanner: _propTypes.default.object.isRequired,
  bannerSize: _propTypes.default.oneOf(['728x90', '300x250']),
  rounded: _propTypes.default.bool,
  padding: _propTypes.default.bool,
  sponsored: _propTypes.default.string,
  sponsoredColor: _propTypes.default.string,
  ..._patternLibraryUtils.marginProps,
  ..._patternLibraryUtils.paddingProps
};